import { useEffect, useState } from 'react'
import { getEntityDataForUpload } from '../../apis/fetchPresignedUrl.api'
import { STRINGS } from '../../utils/strings'
import { isEmpty } from 'lodash'
import 'react-pdf/dist/esm/Page/TextLayer.css'
import 'react-pdf/dist/esm/Page/AnnotationLayer.css'
import { Accordion, PdfViewer, SkeletonLoader } from '@ui-kit'
import { DocumentPreviewType } from '../../types/workflow.types'
import { fetchFilePreviewUrlUsingFileName } from '../../apis/exportFile.api'
const DocumentPreviewTask = ({ task }: DocumentPreviewType) => {
  const [dataForPreview, setDataForPreview] = useState<string | null>(null)
  const [loadingText, setLoadingText] = useState('')
  const fetchDataForDocumentPreview = async () => {
    try {
      const apiResult = await getEntityDataForUpload(
        STRINGS.MULTI_UPLOAD_FIELDS_REQUIRED,
        task?.resource_id ? +task.resource_id : 0
      )

      if (apiResult?.data?.attachment?.length) {
        const fileName =
          apiResult?.data?.attachment?.[0]?.path +
          apiResult?.data?.attachment?.[0]?.name
        const finalData = await fetchFilePreviewUrlUsingFileName(fileName)
        setTimeout(() => {
          setDataForPreview(finalData?.data?.url)
        }, 0)
      } else {
        setLoadingText(STRINGS.NO_DOCUMENT_FOUND)
        setDataForPreview(null)
      }
    } catch (error) {
      setDataForPreview(null)
      setLoadingText(STRINGS.NO_DOCUMENT_FOUND)
      console.error(error)
    }
  }
  const renderSelectorOrMessage = () => {
    if (isEmpty(loadingText)) {
      return <SkeletonLoader />
    } else return <p className="text-center py-4">{loadingText}</p>
  }

  useEffect(() => {
    if (task) fetchDataForDocumentPreview()
  }, [task])
  return (
    <>
      {!isEmpty(dataForPreview) ? (
        <Accordion heading={task?.name ?? ''} alwaysOpen>
          <div className="border border-accent-200 w-full bg-white mt-2 p-4 rounded-md min-h-[20vh] overflow-auto">
            <div className="flex justify-center">
              <div className="flex flex-col items-center w-full max-w-[60rem]">
                <PdfViewer
                  showLoader={true}
                  pdfUrl={dataForPreview ?? ''}
                  showPageNumber={false}
                />
              </div>
            </div>
          </div>
        </Accordion>
      ) : (
        renderSelectorOrMessage()
      )}
    </>
  )
}

export default DocumentPreviewTask
